import { render } from "./ListaVentas.vue?vue&type=template&id=0a358d22"
import script from "./ListaVentas.vue?vue&type=script&lang=js"
export * from "./ListaVentas.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\COSMI\\Desktop\\appwebantiguo\\vue-op-vanguardia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__